export default "__VITE_ASSET__da6dedb6__"